import { cn } from "../../../helpers/utils";

export default function DefaultButton({
  label,
  className,
  type = "button",
  ...props
}) {
  return (
    <button
      type={type}
      className={cn(
         "rounded-md px-4 py-3 font-league-medium w-full text-white",
         props.disabled
         ? "bg-disableVestelColor hover:bg-disableVestelColor"
         : "bg-vestelColor hover:bg-vestelHoverColor",
         className
       )
      }
      {...props}
    >
      {label}
    </button>
  );
}
